export enum MessageType {
    WARNING = 'Warning',
    ERROR = 'Error',
    INFORMATION = 'Information',
    SUCCESS = 'Success',
}
